/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import cx from 'classnames';
import React from 'react';

import { useQuickSetupContext } from '../../../hooks/useQuickSetupContext';

interface StepProps {
  /**
   * A className to add extra styling to step container.
   */
  className?: string;
  /**
   *
   */
  label?: string;
  /**
   * Step secondary Label - description of step shown
   * under the Label.
   */
  secondaryLabel?: string;
  /**
   * if Step is Required -- will be block next steps
   * until `markStepComplete` is called.
   */
  required?: boolean;
  /**
   * Children
   */
  children: JSX.Element;
  /**
   * Title - used in the tooltip
   */
  title?: string;
}
export const Step = (props: StepProps) => {
  const { clearSteps, markStepComplete, setStepFilter, readOnly } =
    useQuickSetupContext();
  return (
    <div className={cx('Step__container', props.className)}>
      {React.Children.map(props.children, child => {
        return React.cloneElement(child, {
          clearSteps,
          setStepFilter,
          markStepComplete,
          readOnly
        });
      })}
    </div>
  );
};
